export default __webpack_public_path__ + "static/media/back button_appointment form.4877a3c4.svg";